import { normalizeRank } from "../../utils/normalizeRank";

export default function MostImprovedCard({ results }) {
  const filtered = results.filter(
    (r) => r.rankingType === "National" && r.resultStatus === "Normal"
  );

  const groups = {};
  filtered.forEach((r) => {
    const key = `${r.playerId}_${r.ageGroup}`;
    if (!groups[key]) {
      groups[key] = { name: r.playerName, ageGroup: r.ageGroup, ranks: [] };
    }
    const normalized = normalizeRank(r);
    if (normalized !== null) {
      groups[key].ranks.push(normalized);
    }
  });

  let bestPlayer = null;
  let bestImprovement = -Infinity;

  Object.values(groups).forEach((data) => {
    if (data.ranks.length > 1) {
      const worst = data.ranks.reduce((a, b) => (a.value > b.value ? a : b));
      const best = data.ranks.reduce((a, b) => (a.value < b.value ? a : b));
      const improvement = worst.value - best.value;
      if (improvement > bestImprovement) {
        bestImprovement = improvement;
        bestPlayer = {
          playerName: data.name,
          ageGroup: data.ageGroup,
          improvement,
          worst: worst.label,
          best: best.label,
        };
      }
    }
  });

  let arrow = "➖";
  let color = "text-gray-500";
  let displayValue = "0";

  if (bestPlayer && bestPlayer.improvement > 0) {
    arrow = "▲";
    color = "text-green-600 font-bold";
    displayValue = `${bestPlayer.improvement}`;
  } else if (bestPlayer && bestPlayer.improvement < 0) {
    arrow = "▼";
    color = "text-red-600 font-bold";
    displayValue = `${bestPlayer.improvement}`;
  }

  return (
    <div className="p-4 bg-white shadow rounded-xl">
      <h1 className="mb-4">Most Improved Results (National)</h1>
      {bestPlayer ? (
        <>
          <p className="font-medium">{bestPlayer.playerName}</p>
          <p className="text-sm text-gray-500 mb-2">
            ({bestPlayer.ageGroup})
          </p>
          <p className={`text-lg ${color}`}>
            {arrow} {displayValue} &nbsp;
            <span className="text-sm text-gray-600">
              ({bestPlayer.worst} → {bestPlayer.best})
            </span>
          </p>
        </>
      ) : (
        <p>No data</p>
      )}
    </div>
  );
}